import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListAffiliatePayoutMethodsResponse } from './list-affiliate-payout-methods.types'

const listAffiliatePayoutMethods =
  async (): Promise<ListAffiliatePayoutMethodsResponse> => {
    const response = await apiClient.get<ListAffiliatePayoutMethodsResponse>(
      '/v1/affiliation/payout-methods',
    )
    return response.data
  }

export const useListAffiliatePayoutMethods = () => {
  return useQuery({
    queryKey: ['affiliate-payout-methods'],
    queryFn: () => listAffiliatePayoutMethods(),
  })
}
